import React,  { useState, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import contactImg from "../../img/creeteam-639467830.jpg";
import "./Configure.scss";

import Typography from "@material-ui/core/Typography";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Avatar from "@material-ui/core/Avatar";

import MountingOptions from "../Configure/Steps/MountingOptions/MountingOptions";
import Configurations from "../Configure/Steps/Configurations/Configurations";
import Length from "../Configure/Steps/Length/Length";
import Quantity from "../Configure/Steps/Quantity/Quantity";
import Uplight, {
  validOptions as UplightValidOptions
} from "../Configure/Steps/Uplight/Uplight";
import DownlightOutput from "../Configure/Steps/DownlightOutput/DownlightOutput";
import DownlightOptic from "../Configure/Steps/DownlightOptic/DownlightOptic";
import CRI from "../Configure/Steps/CRI/CRI";
import CCT from "../Configure/Steps/CCT/CCT";
import Voltage from "../Configure/Steps/Voltage/Voltage";
import Controls from "../Configure/Steps/Controls/Controls";
import SuspensionLength, {
  validOptions as SuspensionLengthValidOptions
} from "../Configure/Steps/SuspensionLength/SuspensionLength";
import CeilingType, {
  validOptions as CeilingTypeValidOptions
} from "../Configure/Steps/CeilingType/CeilingType";
import Color from "../Configure/Steps/Color/Color";
import Options from "../Configure/Steps/Options/Options";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import ACTIONS from "../../actions/action";
import { connect } from "react-redux";
import ContactForm from "../ContactForm/ContactForm";
import ContactUsForm from "../ContactUsForm/ContactUsForm";

import _ from "lodash";
import { config } from "rxjs";
import { crossDomainPost } from "../../utils/iframe_form";
import { spec_sheet, downloadMappings } from "../Bom/SkuCard/SkuCard";

import {
  additional_options_readable,
  cri_readable,
  cct_readable,
  ceiling_type_readable,
  color_readable,
  controls_readable,
  downlight_output_2_readable,
  low_medium_high,
  mounting_options_readable,
  configurations_readable,
  voltage_readable
} from "../Bom/SkuCard/SkuCard";

const useStyles = makeStyles(theme => ({
  connectorCompleted: {
    "& $connectorLine": {
      borderColor: theme.palette.primary.main
    }
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRadius: 0
  },
  actionsContainer: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(3),
    //borderTop: "3px solid #f3f3f3"
  },
  resetContainer: {
    padding: theme.spacing(3)
  },
  appBrandingText: {
    fontSize: 44,
    lineHeight: 1,
    marginTop: 10
  },
  stepperRoot: {
    marginTop: theme.spacing(3),
    paddingLeft: 0
  },
  bomRoot: {
    padding: theme.spacing(2)
  },
  bomSummary: {
    fontSize: 14,
    marginBottom: theme.spacing(2),
    span: {
      color: "white"
    }
  },
  currentSKU: {
    fontSize: 14,
  },
  contactRoot: {
    padding: theme.spacing(2, 3),
    backgroundColor: "#F7F7F7",
    borderTop: "3px solid #FFC000",
    marginTop: theme.spacing(5)
  },
  rightIcon: {
    marginRight: 10
  },
  // contactImage: {
  //   margin: "10px auto",
  //   width: 120,
  //   height: 120
  // },
  contactModal: {
    textAlign: "left"
  },
  contactThanks: {
    textAlign: "center",
    paddingLeft: "5%",
    paddingRight: "5%"
  }
}));

const stepKeys = [
  "mountingOptions",
  "configurations",
  "length",
  "quantity",
  "uplightOutput",
  "downlightOutput",
  "cri",
  "cct",
  "voltage",
  "downlightOptic",
  "controls",
  "suspensionLength",
  "ceilingType",
  "color",
  "additionalOptions"
];

function getSteps() {
  return [
    "Mounting Options",
    "Configurations",
    "Length/Linear Feet",
    "Quantity",
    "Uplight Output",
    "Downlight Output",
    "CRI",
    "Correlated Color Temperatures (CCT)",
    "Voltage",
    "Downlight Optic",
    "Controls",
    "Suspension Length",
    "Ceiling Type",
    "Luminaire Color",
    "Additional Options"
  ];
}

function getStepContent(step, props, setNextEnabled) {
  switch (step) {
    case 0:
      return <MountingOptions setNextEnabled={setNextEnabled} {...props} />;
    case 1:
      return <Configurations setNextEnabled={setNextEnabled} {...props} />;
    case 2:
      return <Length setNextEnabled={setNextEnabled} {...props} />;
    case 3:
      return <Quantity setNextEnabled={setNextEnabled} {...props} />;
    case 4:
      return <Uplight setNextEnabled={setNextEnabled} {...props} />;
    case 5:
      return <DownlightOutput setNextEnabled={setNextEnabled} {...props} />;
    case 6:
      return <CRI setNextEnabled={setNextEnabled} {...props} />;
    case 7:
      return <CCT setNextEnabled={setNextEnabled} {...props} />;
    case 8:
      return <Voltage setNextEnabled={setNextEnabled} {...props} />;
    case 9:
      return <DownlightOptic setNextEnabled={setNextEnabled} {...props} />;
    case 10:
      return <Controls setNextEnabled={setNextEnabled} {...props} />;
    case 11:
      return <SuspensionLength setNextEnabled={setNextEnabled} {...props} />;
    case 12:
      return <CeilingType setNextEnabled={setNextEnabled} {...props} />;
    case 13:
      return <Color setNextEnabled={setNextEnabled} {...props} />;
    case 14:
      return <Options setNextEnabled={setNextEnabled} {...props} />;
    default:
      return "Well...how did I get here?";
  }
}

function Configure(props) {
  window.crossDomainPost = crossDomainPost;

  const {
    configuration,
    saveConfig,
    billOfMaterials,
    viewBom,
    createItem,
    clearPii,
    pii,
    localeSetting
  } = props;

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [openQuote, setOpenQuote] = React.useState(false);
  const [skipped, setSkipped] = React.useState(new Set());
  const [nextEnabledObj, setNextEnabledInState] = React.useState({
    enabled: false,
    msg: null,
    highestCompleted: 0
  });
  const [quoteCompleted, setQuoteCompleted] = React.useState(false);
  const [quoteInvalid, setQuoteInvalid] = React.useState(false);
  let nextEnabled = nextEnabledObj.enabled;
  //let nextEnabled = false;

  const steps = getSteps();

  let currentStep = { index: activeStep, name: steps[activeStep] };

  let productSKU = [
    "ST3",
    configuration.mountingOptions,
    configuration.length,
    configuration.uplightOutput,
    configuration.downlightOutput,
    configuration.cct,
    configuration.downlightOptic,
    configuration.controls,
    configuration.suspensionLength,
    configuration.ceilingType,
    configuration.color
  ];

  // if(configuration.configurations != "Blank")
  //   productSKU.splice(2, 0, configuration.configurations);

  if(configuration.cri != "Blank")
    productSKU.splice(5, 0, configuration.cri);

  if(configuration.voltage != "Blank"){
    if(configuration.cri != "Blank"){
      productSKU.splice(7, 0, configuration.voltage);
    }else{
      productSKU.splice(6, 0, configuration.voltage);
    }
  }

  if(configuration.additionalOptions != "N")
    productSKU.push(configuration.additionalOptions);

  useEffect(updateNextButton, [activeStep]);
  // updateNextButton();

  function setNextEnabled(boolVal, msg = null, highestCompleted = 0) {
    setNextEnabledInState({
      enabled: boolVal,
      msg: msg,
      highestCompleted: highestCompleted
    });
  }

  function updateNextButton() {
    //moved all logic for active next to here
    if (currentStep.name === "Uplight Output") {
      if (
        // !nextEnabled &&
        !UplightValidOptions.includes(configuration.mountingOptions)
      ) {
        setNextEnabled(true, "Only available with Suspended Direct/Indirect and Wall Mount Direct/Indirect mounting options.");
        createItem({ id: stepKeys[currentStep.index], value: null });
      }
    }

    if (currentStep.name === "Ceiling Type") {
      if (
        // !nextEnabled &&
        !CeilingTypeValidOptions.includes(configuration.mountingOptions)
      ) {
        setNextEnabled(true, "Only available with Suspended Direct, Suspended Direct/Indirect, and Recessed mounting options.");
        createItem({ id: stepKeys[currentStep.index], value: null });
      }
    }

    if (currentStep.name === "Suspension Length") {
      if (
        // !nextEnabled &&
        !SuspensionLengthValidOptions.includes(configuration.mountingOptions)
      ) {
        setNextEnabled(true, "Only available with Suspended Direct and Suspended Direct/Indirect mounting options.");
        createItem({ id: stepKeys[currentStep.index], value: null });
      }
    }

    if (
      // !nextEnabled && 
      configuration[stepKeys[currentStep.index]]
      ) {
      // setNextEnabled(true, "Not Applicable");
      setNextEnabled(true);
    }
  }

  function isStepOptional(step) {
    // return step === steps.length-1;//last step is optinal
  }

  function isStepSkipped(step) {
    return skipped.has(step);
  }

  // function handleNext() {
  //     setActiveStep(prevActiveStep => prevActiveStep + 1);
  // }

  function handleNext(event, value) {
    
    setNextEnabled(false);

    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1);

    setSkipped(newSkipped);

    console.log("Configuration: ", configuration);
    console.log(currentStep.name);

    //const nextInterval = setInterval(function () {}, 17);

    setTimeout(function () {
      window.scrollTo(window.pageXOffset,window.pageYOffset+1);
      window.scrollTo(window.pageXOffset,window.pageYOffset-1);
      //clearInterval(nextInterval);
    },750);

    //TODO: get step key and value and set in store
    // createItem({id:"stepKEYNeededHere"+activeStep,value:"stepValue"+activeStep+new Date().toLocaleString()});
  }

  function jumpToStep(stepIndex) {
    setNextEnabled(true);

    setActiveStep(stepIndex);

    console.log("Configuration: ", configuration);
    //TODO: get step key and value and set in store
    // createItem({id:"stepKEYNeededHere"+activeStep,value:"stepValue"+activeStep+new Date().toLocaleString()});
  }

  function handleBack() {
    // console.log("steps[activeStep]:", steps[activeStep]);
    // console.log("currentStep.name:", currentStep.name);
   
    setActiveStep(prevActiveStep => prevActiveStep - 1);  
    
    
    // const prevInterval = setInterval(function () {
    //   window.scrollTo(window.pageXOffset,window.pageYOffset+1);
    //   window.scrollTo(window.pageXOffset,window.pageYOffset-1);
    //       }, 17);

    // setTimeout(function () {
    //   clearInterval(prevInterval);
    // },2000);
  }
  function handleSkip() {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1);

    setSkipped(prevSkipped => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  }
  function handleReset() {
    setActiveStep(0);
  }
  function handleClick() {
    return <ContactForm />;
  }
  function modalOpen() {
    setOpen(true);
  }

  function modalClose() {
    clearPii();
    setOpen(false);
    setQuoteCompleted(false);
    setQuoteInvalid(false);
  }

  function quoteModalOpen() {
    setOpenQuote(true);
  }

  function quoteModalClose() {
    clearPii();
    setOpenQuote(false);
    setQuoteCompleted(false);
    setQuoteInvalid(false);
  }

  function bomToString() {
    let fixedWith = 25;
    let str = "";
    billOfMaterials.forEach(row => {
      let productSKU = [
        "ST3",
        row.mountingOptions,
        row.length,
        row.uplightOutput,
        row.downlightOutput,
        row.cct,
        row.downlightOptic,
        row.controls,
        row.suspensionLength,
        row.ceilingType,
        row.color
      ];
    
      if(row.cri != "Blank")
        productSKU.splice(5, 0, row.cri);
    
      if(row.voltage != "Blank")
        productSKU.splice(6, 0, row.voltage);
    
      if(row.additionalOptions != "N")
        productSKU.push(row.additionalOptions);

      let sku = productSKU.filter(x => x).join("-");

      let documents = _.find(downloadMappings,{
        "Mounting": row.mountingOptions,
        "Uplight Level": row.uplightOutput?row.uplightOutput:"",
        "Downlight Level": row.downlightOutput,
        "Length": row["configurations"] == "Blank" ? parseInt(row.length) : 2
      });

      str += _.padEnd("SKU:", fixedWith) + ntb(sku) + "\n";
      str += _.padEnd("Quantity:", fixedWith) + ntb(row.quantity) + "\n";
      str += _.padEnd("Total Linear Feet:", fixedWith) + ntb(row.tlf) + "\n";
      str += "\n";
      str +=
        _.padEnd("Mounting Options:", fixedWith) +
        ntb(mounting_options_readable[row.mountingOptions]) +
        "\n";


      str +=
        _.padEnd("Configuration:", fixedWith) +
        ntb(configurations_readable[row.configurations]) +
        "\n";
        if(row["configurations"] != "C"){
          if(Number.isInteger(parseInt(row.length))){
            str += _.padEnd("Length/Linear Feet:", fixedWith) + ntb(row.length) + "\n";
          } else{
            if(config.configurations != "S"){
              let dimensions = parseInt(row.sideA) + "'";
              if(parseInt(row.sideB) > 0){
                dimensions += "x" + parseInt(row.sideB) + "'";
              }
              if(parseInt(row.sideC) > 0){
                dimensions += "x" + parseInt(row.sideC) + "'";
              }
              str += _.padEnd("Length/Linear Feet:", fixedWith) + ntb(dimensions) +"\n";
            }else{
              str += _.padEnd("Length/Linear Feet:", fixedWith) + ntb(row.sideA) + "'x" + ntb(row.sideA) + "'" + "\n";
            }
          }
        }else{
          str += _.padEnd("Corners:", fixedWith) + ntb(row.sideA) + "\n";
        }


      str += _.padEnd("Length:", fixedWith) + ntb(row.length) + "\n";
      str +=
        _.padEnd("Uplight Output:", fixedWith) +
        ntb(low_medium_high[row.uplightOutput]) +
        "\n";
      str +=
        _.padEnd("Downlight Output:", fixedWith) +
        ntb(low_medium_high[row.downlightOutput]) +
        "\n";

      str +=
        _.padEnd("CRI:", fixedWith) +
        ntb(cri_readable[row.cri]) +
        "\n";

      str +=
        _.padEnd("Correlated Color Temp:", fixedWith) +
        ntb(cct_readable[row.cct]) +
        "\n";
      str +=
        _.padEnd("Voltage:", fixedWith) +
        ntb(voltage_readable[row.voltage]) +
        "\n";
      str +=
        _.padEnd("Controls:", fixedWith) +
        ntb(controls_readable[row.controls]) +
        "\n";
      str +=
        _.padEnd("Suspension Length:", fixedWith) +
        ntb(row.suspensionLength) +
        "\n";
      str +=
        _.padEnd("Ceiling Type:", fixedWith) +
        ntb(ceiling_type_readable[row.ceilingType]) +
        "\n";
      str +=
        _.padEnd("Luminaire Color:", fixedWith) +
        ntb(color_readable[row.color]) +
        "\n";
      str +=
        _.padEnd("Additional Options:", fixedWith) +
        ntb(additional_options_readable[row.additionalOptions]) +
        "\n";
      str += "\n";
      str += _.padEnd("Spec Sheet:", fixedWith) + "\n" + _.padEnd(ntb(spec_sheet[row.mountingOptions]), fixedWith) + "\n\n";
      str += _.padEnd("IES Files:", fixedWith) + "\n" + _.padEnd(ntb(documents["Link"]), fixedWith) + "\n";
      str += "-------------------------------------------------------";
      str += "\n";
    });

    console.log(str);

    return str;
  }

  function ntb(val) {
    return val ? val : "";
  }

  function submitGetAQuote() {
    let contactData = _.cloneDeep(pii);

    if (
      contactData.privacy_policy !== "Yes" ||
      contactData.communication !== "Yes" ||
      !contactData.first_name ||
      !contactData.last_name ||
      !contactData.phone ||
      !contactData.city ||
      !contactData.state ||
      !contactData.company ||
      !contactData.email
    ) {
      setQuoteInvalid(true);
      return;
    }

    if(localeSetting.state == "Province" && !contactData.country){
      setQuoteInvalid(true);
      return;
    }

    contactData.bill_of_materials = bomToString();

    crossDomainPost(
      "https://go.pardot.com/l/64562/2019-07-03/d31ydd",
      contactData
    );

    // crossDomainPost('https://go.pardot.com/l/64562/2019-07-03/d31ydd',{
    //     "occupation": "Occupation",
    //     "comments": "Comments",
    //     "bill_of_materials":"Bill of Materials 3",
    //     "email":"rlocklear+20190718212014@gmail.com",
    //     "first_name":"Robert",
    //     "last_name":"Locklear",
    //     "privacy_policy":"Yes",
    //     "communication":"Yes",
    //     "phone":"9104740330",
    //     "city":"City",
    //     "state":"State",
    //     "company":"Company"
    // });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'formSubmission', 'formType': 'Request a quote'});

    //modalClose();
    setQuoteCompleted(true);
  }

  function submitContactUs() {
    let contactData = _.cloneDeep(pii);

    if (
      contactData.privacy_policy !== "Yes" ||
      contactData.communication !== "Yes" ||
      !contactData.email ||
      !contactData.first_name ||
      !contactData.last_name ||
      !contactData.phone ||
      !contactData.city ||
      !contactData.company ||
      !contactData.state
    ) {
      setQuoteInvalid(true);
      return;
    }

    if(localeSetting.state == "Province" && !contactData.country){
      setQuoteInvalid(true);
      return;
    }

    if(contactData.country == "CA"){
        crossDomainPost(
          "https://www2.cree.com/l/64562/2020-10-21/f41gr8",
          contactData
        );
      }else{
        crossDomainPost(
          "https://go.pardot.com/l/64562/2019-07-10/d37236",
          contactData
        );
      }

    // https://www2.cree.com/l/64562/2020-10-21/f41gr8
    // crossDomainPost(
    //   "https://go.pardot.com/l/64562/2019-07-10/d37236",
    //   contactData
    // );

    // crossDomainPost('https://go.pardot.com/l/64562/2019-07-03/d31ydd',{
    //     "occupation": "Occupation",
    //     "comments": "Comments",
    //     "bill_of_materials":"Bill of Materials 3",
    //     "email":"rlocklear+20190718212014@gmail.com",
    //     "first_name":"Robert",
    //     "last_name":"Locklear",
    //     "privacy_policy":"Yes",
    //     "communication":"Yes",
    //     "phone":"9104740330",
    //     "city":"City",
    //     "state":"State",
    //     "company":"Company"
    // });
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'formSubmission', 'formType': 'Contact us'});

    //modalClose();
    setQuoteCompleted(true);
  }

  return (
    <div className="config-wrapper">
      <div className="config-form">
        <div className="app-branding">
          <Typography variant="overline" display="block" gutterBottom>Styllus Linear&trade; Series</Typography>
          <Typography
            classes={{ h2: classes.appBrandingText }}
            variant="h2"
            color="primary"
          >
            Build a Configuration.<br/><strong>Get a Quote.</strong>
          </Typography>
        </div>
        <hr />
        <Typography variant="body2" gutterBottom="true">
          Configure the Styllus Linear&trade; Series product that best fits your
          needs and request a quote from a Cree Lighting representative.
        </Typography>
        <Stepper
          activeStep={activeStep}
          orientation="vertical"
          classes={{ root: classes.stepperRoot }}
        >
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepOptional(index)) {
              labelProps.optional = (
                <Typography variant="caption">Optional</Typography>
              );
            }

            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }

            stepProps.completed = typeof configuration[stepKeys[index]] !== "undefined";

            stepProps.value = configuration[stepKeys[index]];

            return (
              <Step key={label} {...stepProps}>
                <StepLabel
                  onClick={() => {
                    if (typeof stepProps.value !== "undefined")
                      jumpToStep(index);
                    //alert('here: '+stepProps.completed)
                  }}
                  {...labelProps}
                >
                  {label}
                </StepLabel>
                <StepContent>
                  <Typography>
                    <em style={{ fontSize: 14 }}>{nextEnabledObj.msg}</em>
                    {getStepContent(index, props, setNextEnabled)}
                  </Typography>
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.button}
                        variant="contained"
                        color="default"
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          if (activeStep === steps.length - 1) {
                            saveConfig();
                            setActiveStep(0, props);

                            window.dataLayer.push({
                              'event': 'productConfigured',
                              'sku': productSKU.filter(x => x).join("-"),
                             });

                            //  window.scrollTo(0, 0);
                            
                          } else {
                            
                              handleNext();
                              
                      
                            // handleNext();
                            // window.scrollTo(window.scrollX,window.scrollY+1);
                            // window.scrollTo(window.scrollX,window.scrollY-1);
                          }
                        }}
                        className={classes.button}
                        disabled={!nextEnabled}
                      >
                        {activeStep === steps.length - 1 ? "Finish" : "Next"}
                      </Button>
                      <br />
                      <br />
                      {activeStep === steps.length - 1 && (
                        <Typography variant="caption">
                          You'll be able to review your Bill of Materials before
                          requesting a quote.
                        </Typography>
                      )}
                    </div>
                  </div>
                </StepContent>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length && (
          <Paper square elevation={0} className={classes.resetContainer}>
            <Typography>Complete!</Typography>
            <Button
              onClick={() => {
                saveConfig();
                setActiveStep(0, props);
              }}
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              Add to Bill of Materials
            </Button>
            <br />
            <br />
            <Typography variant="caption">
              You'll be able to review your Bill of Materials before requesting
              a quote.
            </Typography>
          </Paper>
        )}
      </div>
      <div className="config-sidebar">
        <div className="sidebar-stick">
          {billOfMaterials.length > 0 && (
            <Paper classes={{ root: classes.bomRoot }} square elevation={4}>
              <Typography
                variant="body2"
                classes={{ body2: classes.bomSummary }}
              >
                You have <span className="bom-count" onClick={viewBom}>({billOfMaterials.length})</span> product{billOfMaterials.length > 1 && (('s'))} on
                your Bill of Materials
              </Typography>
              <Button
                onClick={quoteModalOpen}
                variant="contained"
                color="secondary"
                fullWidth={true}
                className={classes.button}
                // onClick={modalOpen}
              >
                Request a Quote
              </Button>
              <Button
                variant="contained"
                color="default"
                fullWidth={true}
                className={classes.button}
                onClick={() => {
                  // window.scrollTo(0, 0);
                  viewBom();
                }}
              >
                View Bill Of Materials
              </Button>
            </Paper>
          )}

          <Paper classes={{ root: classes.contactRoot }} square elevation={0}>
            <Typography variant="body2" classes={{ body2: classes.currentSKU }}>
              Your current product SKU:
            </Typography>
            <Typography variant="subtitle" className="sku-preview">
              {productSKU.filter(x => x).join("-")}
            </Typography>
          </Paper>

          <Paper classes={{ root: classes.contactRoot }} square elevation={0}>
            <img
              alt="CREE Design Team"
              src={contactImg}
              className="contactImage"
            />
            <Typography variant="h6" gutterBottom="true">
              Questions?
            </Typography>
            <Typography variant="body2" classes={{ body2: classes.bomSummary }}>
              For more information on the Styllus Linear&trade; Series, speak to
              a Cree Lighting representative.
            </Typography>
            <Button onClick={modalOpen} color="primary" fullWidth={true}>
              Contact Us
              <ChevronRightIcon className={classes.rightIcon} />
            </Button>
          </Paper>
        </div>

        {/* Request a Quote Modal */}
        <Dialog
          open={openQuote}
          onClose={quoteModalClose}
          scroll="paper"
          maxWidth="md"
          className={classes.contactModal}
          aria-labelledby="Get a Quote"
        >
          <DialogTitle disableTypography>Request a Quote</DialogTitle>
          <DialogContent>
          {quoteCompleted && (
              <div className={classes.contactThanks}>
                <h2>Thank you!</h2>
                <p>
                  Your information has been submitted. A confirmation of your
                  quote request and a copy of your product details has been sent
                  to the email provided.
                </p>
              </div>
            )}

            {!quoteCompleted && <ContactForm {...props} />}
          </DialogContent>
          <DialogActions>
          {quoteInvalid && !quoteCompleted && (
              <p style={{ color: "red", margin: "0 30px 0 0" }}>
                Please check all required fields and try submitting again
              </p>
            )}

            {!quoteCompleted && (
              <React.Fragment>
                <Button onClick={quoteModalClose} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={submitGetAQuote}
                  variant="contained"
                  color="secondary"
                >
                  Submit
                </Button>
              </React.Fragment>
            )}

            {quoteCompleted && (
              <React.Fragment>
                <Button onClick={quoteModalClose} color="primary">
                  Close
                </Button>
              </React.Fragment>
            )}
          </DialogActions>
        </Dialog>

        {/* Contact Modal */}
        <Dialog
          open={open}
          onClose={modalClose}
          scroll="paper"
          maxWidth="md"
          className={classes.contactModal}
          aria-labelledby="Contact Us"
        >
          <DialogTitle disableTypography>Contact Us</DialogTitle>
          <DialogContent>
            {quoteCompleted && (
              <div>
                <h2>Thank you!</h2>
                <p>Your information has been submitted.</p>
              </div>
            )}

            {!quoteCompleted && <ContactUsForm {...props} />}
          </DialogContent>
          <DialogActions>
            {quoteInvalid && !quoteCompleted && (
              <p style={{ color: "red", margin: "0 30px 0 0" }}>
                Please check all required fields and try again!
              </p>
            )}
            {!quoteCompleted && (
              <React.Fragment>
                <Button onClick={modalClose} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={submitContactUs}
                  variant="contained"
                  color="secondary"
                >
                  Submit
                </Button>
              </React.Fragment>
            )}

            {quoteCompleted && (
              <React.Fragment>
                <Button onClick={modalClose} color="primary">
                  Close
                </Button>
              </React.Fragment>
            )}
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  configuration: state.configuration,
  billOfMaterials: state.billOfMaterials,
  pii: state.pii,
  localeSetting: state.localeSettings
});

const mapDispatchToProps = dispatch => ({
  createItem: item => dispatch(ACTIONS.setConfigItem(item)),
  deleteConfig: id => dispatch(ACTIONS.deleteConfig(id)),
  saveConfig: () => dispatch(ACTIONS.saveConfig()),
  viewBom: () => dispatch(ACTIONS.viewBom()),
  setQuoteItem: item => dispatch(ACTIONS.setQuoteItem(item)),
  clearPii: () => dispatch(ACTIONS.clearPii())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Configure);
//(withStyles(styles)
